import { SOURCE_TYPE } from './globals';

export const IOS_TECHNOLOGY_KEY = 'ios';
export const XCARCHIVE_FILE_EXTENSION = '.xcarchive.zip';

const XCARCHIVE_ELIGIBLE_SOURCE_TYPES: readonly string[] = [
  SOURCE_TYPE.HYBRID,
  SOURCE_TYPE.WHITELABEL,
];

// iOS hybrid/whitelabel apps are the only ones allowed to upload a zipped
// xcarchive instead of a signed ipa.
export function isXcarchiveEligibleApp(
  technology: string,
  sourceCodeType: string,
): boolean {
  return (
    technology === IOS_TECHNOLOGY_KEY &&
    XCARCHIVE_ELIGIBLE_SOURCE_TYPES.includes(sourceCodeType)
  );
}

export function isXcarchiveFileName(
  technology: string,
  sourceCodeType: string,
  fileName: string,
): boolean {
  return (
    isXcarchiveEligibleApp(technology, sourceCodeType) &&
    !!fileName?.toLowerCase().endsWith(XCARCHIVE_FILE_EXTENSION)
  );
}
